// ================================================================
// PROPRIETARY & CONFIDENTIAL — Mt Forge Inc.
// Copyright (c) 2026 Mt Forge. All rights reserved.
// Unauthorized copying, reverse engineering, or AI-assisted
// reproduction of this software is strictly prohibited.
// Protected under US Copyright Law (17 U.S.C.) and international
// treaties. Patent Pending. License: PROPRIETARY
// ================================================================
import React, { useState } from "react";

const PROJECTS = [
  { id:1, name:"VitaSync Launch", product:"VitaSync", status:"On Track", progress:72, lead:"Des Bachynski", team:["Des Bachynski","Jordan Lutz","Tyler Hodgson"], deadline:"2026-03-15",
    description:"Full launch of VitaSync health tracking platform for clinics and health providers across western Canada.",
    tasks:[{text:"Beta testing with 3 pilot clinics",done:true},{text:"Compliance documentation update",done:false},{text:"Staff training materials",done:true},{text:"Marketing launch campaign",done:false},{text:"Production deployment",done:false}],
    milestones:[{name:"Beta Complete",date:"2026-02-14",done:true},{name:"Compliance Approved",date:"2026-02-28",done:false},{name:"Launch Day",date:"2026-03-15",done:false}],
    timeline:"Started Jan 15 - Target Mar 15" },
  { id:2, name:"Vantage Ops Verticals", product:"Vantage Ops", status:"On Track", progress:45, lead:"Jordan Lutz", team:["Jordan Lutz","Tyler Hodgson"], deadline:"2026-04-01",
    description:"Expand Vantage Ops to support 3 new service industry verticals: HVAC, plumbing, and electrical.",
    tasks:[{text:"HVAC workflow module",done:true},{text:"Plumbing workflow module",done:false},{text:"Electrical workflow module",done:false},{text:"Cross-vertical reporting",done:false},{text:"Beta testing",done:false}],
    milestones:[{name:"HVAC Module Done",date:"2026-02-10",done:true},{name:"All Modules Done",date:"2026-03-15",done:false},{name:"Release",date:"2026-04-01",done:false}],
    timeline:"Started Jan 20 - Target Apr 1" },
  { id:3, name:"GlowDesk Recording Pages", product:"GlowDesk", status:"At Risk", progress:20, lead:"Jordan Lutz", team:["Jordan Lutz"], deadline:"2026-02-28",
    description:"Build client consultation recording, e-signature consent, and transcription pages for GlowDesk.",
    tasks:[{text:"ClientConsultationsPage build",done:false},{text:"ESignatureConsentPage build",done:false},{text:"TranscriptionsPage build",done:false},{text:"Nav integration",done:false},{text:"Testing and deploy",done:true}],
    milestones:[{name:"Pages Built",date:"2026-02-20",done:false},{name:"Deploy to Cloudflare",date:"2026-02-28",done:false}],
    timeline:"Started Feb 3 - Target Feb 28" },
  { id:4, name:"Canstorr Phase 2 Integration", product:"CropPatrol / CropPatrol", status:"On Track", progress:35, lead:"Tyson Becker", team:["Tyson Becker","Lucas Mason","Jordan Lutz"], deadline:"2026-04-30",
    description:"Phase 2 expansion of Canstorr commodities partnership. New sensor deployment, expanded storage monitoring, and transportation tracking.",
    tasks:[{text:"Sensor hardware procurement",done:true},{text:"Installation scheduling",done:false},{text:"API integration for new bins",done:false},{text:"Transportation module",done:false},{text:"Training documentation",done:false},{text:"Site acceptance testing",done:false}],
    milestones:[{name:"Hardware Ordered",date:"2026-02-15",done:true},{name:"Installation Complete",date:"2026-03-30",done:false},{name:"Go Live",date:"2026-04-30",done:false}],
    timeline:"Started Feb 1 - Target Apr 30" },
  { id:5, name:"Platform API v3", product:"Platform", status:"On Track", progress:55, lead:"Jordan Lutz", team:["Jordan Lutz","Tyler Hodgson"], deadline:"2026-03-31",
    description:"Major API version upgrade with improved authentication, rate limiting, and real-time notification support.",
    tasks:[{text:"API specification document",done:true},{text:"Authentication refactor",done:true},{text:"Rate limiting implementation",done:true},{text:"Real-time notifications",done:false},{text:"Documentation",done:false},{text:"Migration guide",done:false}],
    milestones:[{name:"Spec Approved",date:"2026-01-31",done:true},{name:"Core Features Done",date:"2026-03-01",done:false},{name:"Release",date:"2026-03-31",done:false}],
    timeline:"Started Jan 10 - Target Mar 31" },
  { id:6, name:"Mining Sector Expansion", product:"OreSync", status:"At Risk", progress:15, lead:"Lee Mehling", team:["Lee Mehling","Lucas Mason"], deadline:"2026-05-15",
    description:"Expand OreSync to 3 new mine sites with Western Mining Corp. Includes compliance automation and safety monitoring.",
    tasks:[{text:"Compliance requirements research",done:true},{text:"Site assessment visits",done:false},{text:"Custom compliance module",done:false},{text:"Safety monitoring dashboard",done:false},{text:"Multi-site deployment",done:false},{text:"Staff training",done:false}],
    milestones:[{name:"Requirements Gathered",date:"2026-02-28",done:false},{name:"Module Development",date:"2026-04-15",done:false},{name:"Deployment",date:"2026-05-15",done:false}],
    timeline:"Started Feb 4 - Target May 15" }
];

export default function ActiveProjectsPage() {
  const [projects] = useState(PROJECTS);
  const [view, setView] = useState("cards");
  const [selectedProject, setSelectedProject] = useState(null);

  const onTrack = projects.filter(p => p.status === "On Track").length;
  const atRisk = projects.filter(p => p.status === "At Risk").length;

  const statusBadge = (status) => {
    const map = { "On Track":"badge badge-green", "At Risk":"badge badge-yellow", Completed:"badge badge-blue" };
    return map[status] || "badge";
  };

  return (
    <div>
      <div className="page-header">
        <div><h1 className="page-title">Active Projects</h1><p>{projects.length} active projects</p></div>
        <div style={{display:"flex",gap:8}}>
          <button className={"btn "+(view==="cards"?"btn-primary":"btn-outline")} onClick={() => setView("cards")}>Cards</button>
          <button className={"btn "+(view==="list"?"btn-primary":"btn-outline")} onClick={() => setView("list")}>List</button>
        </div>
      </div>

      <div className="stats-grid">
        <div className="stat-card"><div className="stat-label">Active Projects</div><div className="stat-value">{projects.length}</div></div>
        <div className="stat-card"><div className="stat-label">On Track</div><div className="stat-value" style={{color:"#10b981"}}>{onTrack}</div></div>
        <div className="stat-card"><div className="stat-label">At Risk</div><div className="stat-value" style={{color:"#eab308"}}>{atRisk}</div></div>
        <div className="stat-card"><div className="stat-label">Completed This Quarter</div><div className="stat-value" style={{color:"#3b82f6"}}>2</div></div>
      </div>

      {view === "cards" ? (
        <div className="grid-2">
          {projects.map(p => (
            <div key={p.id} className="card" style={{cursor:"pointer"}} onClick={() => setSelectedProject(p)}>
              <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginBottom:8}}>
                <div>
                  <div style={{fontSize:15,fontWeight:700,color:"#e2e8f0"}}>{p.name}</div>
                  <div style={{fontSize:12,color:"#64748b"}}>{p.product}</div>
                </div>
                <span className={statusBadge(p.status)}>{p.status}</span>
              </div>
              <div style={{marginBottom:10}}>
                <div style={{display:"flex",justifyContent:"space-between",fontSize:12,color:"#94a3b8",marginBottom:4}}>
                  <span>Progress</span><span>{p.progress}%</span>
                </div>
                <div style={{width:"100%",height:6,background:"#334155",borderRadius:3}}>
                  <div style={{width:p.progress+"%",height:6,background:p.status==="At Risk"?"#eab308":"#10b981",borderRadius:3}} />
                </div>
              </div>
              <div style={{display:"flex",justifyContent:"space-between",fontSize:12,color:"#64748b"}}>
                <span>Lead: {p.lead}</span>
                <span>Due: {p.deadline}</span>
              </div>
              <div style={{display:"flex",gap:4,marginTop:8,flexWrap:"wrap"}}>
                {p.team.map(t => <span key={t} style={{fontSize:10,padding:"2px 6px",background:"#1e293b",borderRadius:4,color:"#94a3b8"}}>{t.split(" ").map(n=>n[0]).join("")}</span>)}
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div className="card">
          <table style={{width:"100%",borderCollapse:"collapse"}}>
            <thead>
              <tr style={{borderBottom:"2px solid #334155"}}>
                {["Project","Product","Status","Progress","Lead","Team","Deadline"].map(h => (
                  <th key={h} style={{textAlign:"left",padding:"10px 8px",fontSize:12,fontWeight:700,color:"#94a3b8"}}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {projects.map(p => (
                <tr key={p.id} style={{borderBottom:"1px solid #334155",cursor:"pointer"}} onClick={() => setSelectedProject(p)}>
                  <td style={{padding:"10px 8px",fontSize:13,fontWeight:600,color:"#e2e8f0"}}>{p.name}</td>
                  <td style={{padding:"10px 8px",fontSize:12,color:"#94a3b8"}}>{p.product}</td>
                  <td style={{padding:"10px 8px"}}><span className={statusBadge(p.status)}>{p.status}</span></td>
                  <td style={{padding:"10px 8px"}}><div style={{display:"flex",alignItems:"center",gap:8}}><div style={{width:60,height:6,background:"#334155",borderRadius:3}}><div style={{width:p.progress+"%",height:6,background:p.status==="At Risk"?"#eab308":"#10b981",borderRadius:3}}/></div><span style={{fontSize:12,color:"#e2e8f0"}}>{p.progress}%</span></div></td>
                  <td style={{padding:"10px 8px",fontSize:12,color:"#e2e8f0"}}>{p.lead}</td>
                  <td style={{padding:"10px 8px",fontSize:12,color:"#94a3b8"}}>{p.team.length} members</td>
                  <td style={{padding:"10px 8px",fontSize:12,color:"#94a3b8"}}>{p.deadline}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {selectedProject && (
        <div className="modal-overlay" onClick={() => setSelectedProject(null)}>
          <div className="modal" onClick={e => e.stopPropagation()}>
            <div className="modal-header">
              <h2>{selectedProject.name}</h2>
              <button className="modal-close" onClick={() => setSelectedProject(null)}>X</button>
            </div>
            <div className="modal-body">
              <div style={{display:"flex",gap:12,marginBottom:16,flexWrap:"wrap"}}>
                <span className={statusBadge(selectedProject.status)}>{selectedProject.status}</span>
                <span style={{fontSize:13,color:"#94a3b8"}}>Product: <strong style={{color:"#e2e8f0"}}>{selectedProject.product}</strong></span>
                <span style={{fontSize:13,color:"#94a3b8"}}>Deadline: <strong style={{color:"#e2e8f0"}}>{selectedProject.deadline}</strong></span>
              </div>
              <p style={{fontSize:13,color:"#e2e8f0",lineHeight:1.6,marginBottom:16}}>{selectedProject.description}</p>

              <div style={{marginBottom:16}}>
                <div style={{display:"flex",justifyContent:"space-between",fontSize:12,color:"#94a3b8",marginBottom:4}}><span>Overall Progress</span><span>{selectedProject.progress}%</span></div>
                <div style={{width:"100%",height:8,background:"#334155",borderRadius:4}}><div style={{width:selectedProject.progress+"%",height:8,background:"#10b981",borderRadius:4}} /></div>
              </div>

              <div style={{marginBottom:16}}>
                <h4 style={{fontSize:13,fontWeight:700,color:"#94a3b8",marginBottom:6}}>Team</h4>
                <div style={{display:"flex",gap:6,flexWrap:"wrap"}}>{selectedProject.team.map(t => <span key={t} className="badge badge-purple">{t}</span>)}</div>
              </div>

              <div style={{marginBottom:16}}>
                <h4 style={{fontSize:13,fontWeight:700,color:"#94a3b8",marginBottom:8}}>Tasks ({selectedProject.tasks.filter(t=>t.done).length}/{selectedProject.tasks.length})</h4>
                {selectedProject.tasks.map((t, i) => (
                  <div key={i} style={{display:"flex",alignItems:"center",gap:8,padding:"6px 0",borderBottom:"1px solid #334155"}}>
                    <span style={{color:t.done?"#10b981":"#64748b"}}>{t.done ? "\u2713" : "\u25CB"}</span>
                    <span style={{fontSize:13,color:t.done?"#64748b":"#e2e8f0",textDecoration:t.done?"line-through":"none"}}>{t.text}</span>
                  </div>
                ))}
              </div>

              <div>
                <h4 style={{fontSize:13,fontWeight:700,color:"#94a3b8",marginBottom:8}}>Milestones</h4>
                {selectedProject.milestones.map((m, i) => (
                  <div key={i} style={{display:"flex",justifyContent:"space-between",alignItems:"center",padding:"8px 0",borderBottom:"1px solid #334155"}}>
                    <div style={{display:"flex",alignItems:"center",gap:8}}>
                      <span style={{color:m.done?"#10b981":"#64748b"}}>{m.done ? "\u2713" : "\u25CB"}</span>
                      <span style={{fontSize:13,color:"#e2e8f0"}}>{m.name}</span>
                    </div>
                    <span style={{fontSize:12,color:"#94a3b8"}}>{m.date}</span>
                  </div>
                ))}
              </div>

              <div style={{fontSize:12,color:"#64748b",marginTop:12}}>{selectedProject.timeline}</div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
